import { useEffect, useRef } from 'react';

export const usePreviousValue = <ValueType>(value: ValueType) => {
  const ref = useRef<ValueType>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
